export function parseServerTime(value: string) {
  if (/[zZ]$|[+-]\d{2}:\d{2}$/.test(value)) {
    return Date.parse(value);
  }
  return Date.parse(`${value}Z`);
}

export function computeClockSkewMs(serverNow: string) {
  const serverNowMs = parseServerTime(serverNow);
  if (Number.isNaN(serverNowMs)) {
    return 0;
  }
  return Date.now() - serverNowMs;
}

export function computeRemainingMs(deadline: string, clockSkewMs: number, nowMs = Date.now()) {
  const deadlineMs = parseServerTime(deadline);
  if (Number.isNaN(deadlineMs)) {
    return 0;
  }
  return Math.max(0, deadlineMs - (nowMs - clockSkewMs));
}

export function formatCountdownSeconds(ms: number) {
  return String(Math.min(5, Math.max(1, Math.ceil(Math.max(0, ms) / 1000))));
}
